import { render, staticRenderFns } from "./PoundageSum.vue?vue&type=template&id=1533d309&scoped=true&"
import script from "./PoundageSum.vue?vue&type=script&lang=js&"
export * from "./PoundageSum.vue?vue&type=script&lang=js&"
import style0 from "./PoundageSum.vue?vue&type=style&index=0&id=1533d309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1533d309",
  null
  
)

export default component.exports